cookieman.theme = (function () {
    "use strict";

    cookieman.show = function () {
        $('.CookiePopUp-wrapper').addClass("js-show");
        $('body').addClass('CookieBar-active');
    }
    cookieman.hide = function () {
       $('.CookiePopUp-wrapper').removeClass("js-show");
       $('body').removeClass('CookieBar-active');
    }
}());
